<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules">
      <ul class="error-messages" v-if="!isEmptyErrors">
        <li v-for="(error,index) in errors" :key="index">{{error[0].message}}</li>
      </ul>
      <el-row :gutter="10">
        <el-col :span="24" style="font-size: 10px;margin-bottom: 10px;color:#888;" v-if="rate">
          * 当前{{currency}}参考汇率: {{rate}},提高服务费有助快速接单
        </el-col>
        <el-col :span="6" >
          <!-- <p v-if="taskInfo.support_transport_service == '1'" class="" style="font-size:14px;padding-top: 20px;color:#888;">下单:</p>
          <p v-if="taskInfo.support_transport_service == '2'" class="" style="font-size:14px;padding-top: 20px;color:#888;">下单+转运:</p> -->
          <p class="lighter-gray-txt" style="font-size:10px;padding-top: 9px;line-height: 10px;">订单小计</p>
          <p style="padding-top: 8px;line-height: 14px;">{{taskInfo.total_amount | currency(taskInfo.currency_symbol)}}<span style="float:right;">X</span></p>
        </el-col>
        <el-col :span="8" style="margin-bottom:10px;">
          <YueDanIpt model="service_rate" sub-model="service_fixed_amount" :readonly="true" :object="service" placeholder="服务费率"></YueDanIpt>
        </el-col>
        <el-col :span="2" class="text-center">
          <p style="font-size:14px;padding-top: 20px;color:#888;">即</p>
        </el-col>
        <el-col :span="8" style="margin-bottom:10px;">
          <YueDanIpt model="service_price" :reg="/^\d+\.?\d{0,2}$/" :object="service" v-on:input="calServicePrice" placeholder="服务费"></YueDanIpt>
        </el-col>
        <el-col :span="6">
          <p class="lighter-gray-txt" style="font-size:10px;padding-top: 9px;line-height: 10px;">任务金额</p>
          <p style="padding-top: 8px;line-height: 14px;">{{amount_currency | currency(taskInfo.currency_symbol)}}<span style="float:right;">X</span></p>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="rate">
            <YueDanIpt reg="/^\d+\.?\d{0,4}$/" :readonly="true" model="rate" :object="form" placeholder="实时汇率"></YueDanIpt>
          </el-form-item>
        </el-col>
        <el-col :span="2" class="text-center">
          <p style="padding-top: 25px;">=</p>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="amount">
            <YueDanIpt v-on:input="calAmount" :reg="/^\d+\.?\d{0,2}$/" model="amount" :object="form" placeholder="任务金额"></YueDanIpt>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="taskInfo.support_transport_service === '2'" :gutter="10">
        <el-col :span="8">
          <el-form-item >
            <YueDanIpt :reg="/^\d+\.?\d{0,2}$/"
                       :readonly="form.transport_amount_charge_type === '1' || form.transport_amount_charge_type === '2'"
                       model="package_forwarding_fee" :object="form" placeholder="国际运费"/>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item>
            <el-select class="block height-50" v-model="form.transport_amount_charge_type"  >
              <el-option label="按重量实收" value="1"></el-option>
              <el-option label="包邮/已计 " value="2"></el-option>
              <el-option label="确定金额" value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

      </el-row>
      <el-form-item v-if="!isSingle" prop="single_name">
        <!-- <el-select class="block height-50" v-model="form.single_id" placeholder="">
          <el-option v-for="(single,index) in singleList" :key="index" :label="single.name" :value="single.id"></el-option>
        </el-select> -->
        <YueDanIpt model="single_name" :object="form" placeholder="买手用户名" ></YueDanIpt>

      </el-form-item>
      <el-form-item prop="buyer_name" v-if="isSingle">
        <YueDanIpt model="buyer_name" :object="form" placeholder="买单人" v-on:focusIpt="focusIpt" v-on:blur="buyerBlur"></YueDanIpt>
      </el-form-item>
      <div class="addressName" v-if="isSingle && showAddressName && addressName">最近的买单用户:{{addressName}}</div>
      <el-form-item>
        <el-select class="block height-50" v-model="form.response_hours">
          <el-option label="立即响应" value="立即响应"></el-option>
          <el-option label="48小时内响应" value="48小时内响应"></el-option>
          <el-option label="24小时内响应" value="24小时内响应"></el-option>
          <el-option label="12小时内响应" value="12小时内响应"></el-option>
          <el-option label="2小时内响应" value="2小时内响应"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="false">
        <el-select class="block height-50" v-model="form.score">
          <el-option label="下单人评分" value="下单人评分"></el-option>
          <el-option label="4分以上" value="4分以上"></el-option>
          <el-option label="4.2分以上" value="4.2分以上"></el-option>
          <el-option label="4.5分以上" value="4.5分以上"></el-option>
          <el-option label="4.8分以上" value="4.8分以上"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="remark">
        <el-input placeholder="备注" type="textarea" v-model="form.remark"></el-input>
      </el-form-item>
      <el-form-item>
        <el-checkbox-group v-model="form.check_full_goods">
          <el-checkbox label="部分商品缺货时仍可下单" name="check_full_goods"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <el-button :loading="loading" class="block" :type="btnType || 'info'" @click="submit()">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import YueDanIpt from '../../../components/YueDanIpt'
import api from '../../../services/api.js'
import {CURRENCIES} from '../../../services/constant.js'

let _ = require('lodash')

export default {
  name: 'AddAddress',
  props: ['taskInfo', 'btnType', 'loading'],
  components: {
    YueDanIpt: YueDanIpt
  },
  data () {
    var checkIsPrice = (rule, value, callback) => {
      if (value && (isNaN(value) || value < 0 || value > 9999)) {
        callback(new Error('请输入正确的汇率'))
      } else {
        callback()
      }
    }
    var validateBuyerName = async (rule, value, callback) => {
      console.log(value)
      if (!value) {
        this.form.buyer_id = '0'
        this.isEmptyErrors = true
        this.errors = {}
        return callback()
      }
      let keyword = value.replace(/(^\s*)|(\s*$)/g, '')
      if (!keyword) {
        this.form.buyer_id = '0'
        return callback()
      }
      let { body } = await api.getBuyerList(this, {
        keyword: keyword
      })
      let res = body.result || []
      if (res.length != 1) {
        this.isEmptyErrors = false
        this.errors = {
          buyer_name: [
            {message: '不存在此用户名'}
          ]
        }
        return callback()
      } else {
        this.isEmptyErrors = true
        this.errors = {}
      }
      if (res[0].username != keyword) {
        this.isEmptyErrors = false
        this.errors = {
          buyer_name: [
            {message: '不存在此用户名'}
          ]
        }
        return callback()
      } else {
        this.isEmptyErrors = true
        this.errors = {}
      }
      this.form.buyer_id = res[0].account_id
      callback()
    }
    var validateSingelName = async (rule, value, callback) => {
      if (!value) {
        this.form.single_id = '0'
        this.isEmptyErrors = true
        this.errors = {}
        return callback()
      }
      let username = value.replace(/(^\s*)|(\s*$)/g, '')
      let data = {
        username: username
      }
      let res = await api.post(this, {
        path: 'single.php',
        api: 'is_single_exist',
        data: data
      })
      res = res.body
      if (res.status == 'ok') {
        if (res.result) {
          this.isEmptyErrors = true
          this.errors = {}
        } else {
          this.isEmptyErrors = false
          this.errors = {
            single_name: [
              {message: '不存在此下单人'}
            ]
          }
          return callback()
        }
      }
      callback()
    }
    return {
      showAddressName: false,
      addressName: null,
      service: {
        service_rate: null, // 服务费率
        service_price: null, // 服务费
        service_fixed_amount: null // 固定服务金额
      },
      CURRENCIES: CURRENCIES,
      currency: '',
      isSingle: false,
      errors: null,
      isEmptyErrors: true,
      singleList: null,
      rate: null, // 基准汇率
      rate_difference: null, // 汇率差
      form: {
        single_id: '0', // 下单人
        single_name: null,
        buyer_id: '0', // 下单人
        buyer_name: null,
        rate: 1, // 汇率
        amount_currency: 0, // 任务金额（原币种）
        amount: 0, // 任务金额（人民币）
        response_hours: '立即响应', // 响应时间
        after_sale_service: '不需要售后服务', // 售后服务
        score: '下单人评分', // 评分
        remark: null, // 备注
        check_full_goods: false, // 缺货是否仍可下单，0否，1是
        transport_amount_charge_type: '3', // 运费计费方式，1: 国际邮费按包裹重量实收 2: 国际运费包邮/已记 3: 输入国际邮费金额
        package_forwarding_fee: '0.00' // 国际运费
      },
      rules: {
        rate: [
          { required: true, message: '汇率是必填项', trigger: 'blur' },
          { validator: checkIsPrice, trigger: 'blur' }
        ],
        amount: [
          { required: true, message: '总价是必填项', trigger: 'blur' }
        ],
        remark: [
          { max: 120, trigger: 'blur', message: '备注不能超过120个字符' }
        ],
        buyer_name: [
          { validator: validateBuyerName, trigger: 'blur' }
        ],
        single_name: [
          {validator: validateSingelName, trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    // 原币种-任务金额
    amount_currency(){
      return this.$decimalFormat((this.form.amount/this.rate),2)
    }
  },
  async mounted () {
    console.log('!!!',this.taskInfo)
    
    await this.getSingleList()
    if (!this.taskInfo.service) {
      this.getExchangeRates()
    } else {
      this.service = this.taskInfo.service
      this.rate = this.taskInfo.currencyInfo.rate
      this.form.rate = this.taskInfo.currencyInfo.rate
      let t=((Number(this.taskInfo.total_amount) + Number(this.service.service_price))* Number(this.rate) + Number(this.service.service_fixed_amount))
      this.form.amount = this.$decimalFormat(t,2)
      
    }
    if (this.$route.fullPath.indexOf('buyer') > -1) {
      this.isSingle = true
    } else {
      this.isSingle = false
    }
    let addressName = localStorage.getItem('addressName')
    if (addressName && this.isSingle) {
      this.addressName = addressName
      this.form.buyer_name = addressName
      this.getBuyerName(addressName)
    }
    // 计算国际邮费状态
    this.form.transport_amount_charge_type = this.taskInfo.support_transport_service === '2' ? '1' : '2' || this.form.transport_amount_charge_type
    // 返回页面时显示参数
    if (this.taskInfo.conditions) {
      this.form.rate = this.taskInfo.conditions.rate || this.form.rate
      this.form.single_id = this.taskInfo.conditions.single_id || this.form.single_id
      this.form.single_name = this.taskInfo.conditions.single_name || this.form.single_name
      this.form.buyer_id = this.taskInfo.conditions.buyer_id || this.form.buyer_id
      this.form.buyer_name = this.taskInfo.conditions.buyer_name || this.form.buyer_name
      this.form.response_hours = this.taskInfo.conditions.response_hours || this.form.response_hours
      this.form.remark = this.taskInfo.conditions.remark || this.form.remark
      this.form.check_full_goods = this.taskInfo.conditions.check_full_goods || this.form.check_full_goods
      this.form.package_forwarding_fee = this.taskInfo.conditions.package_forwarding_fee || this.form.package_forwarding_fee
      this.form.transport_amount_charge_type = this.taskInfo.conditions.transport_amount_charge_type || this.form.transport_amount_charge_type
    }
    // this.form.amount = (Number(this.taskInfo.total_amount) * Number(this.form.rate)).toFixed(2)

    if (this.taskInfo.business_id == 4460 && !this.isSingle) {
      this.form.single_id = '105'
      this.form.single_name = 'JoyOrdersTeam'
      this.taskInfo.conditions = this.form
      this.$store.commit('updateTaskInfo', this.taskInfo)
      this.$emit('success')
    }
  },
  methods: {
    buyerBlur () {
      this.showAddressName = false
    },
    focusIpt () {
      this.showAddressName = true
    },
    async getBuyerName (addressName) {
      let { body } = await api.getBuyerList(this, {
        keyword: addressName
      })
      let res = body.result || []
      this.form.buyer_id = res[0].account_id
    },
    async getExchangeRates () {
      let res = await api.getExchangeRates(this)
      console.log('taskInfo.currencyInfo', this.taskInfo.currencyInfo)
      this.rate = this.taskInfo.currencyInfo.rate
      this.form.rate = Number(this.taskInfo.currencyInfo.rate)
      const currencyInfo = this.taskInfo.currencyInfo
      const business = this.taskInfo.business
      if (this.taskInfo.support_transport_service == '1') {
        this.service.service_rate = Number(business.single_service_rate) !== 0 ? business.single_service_rate : currencyInfo.single_service_rate
        this.service.service_fixed_amount = business.single_fixed_amount
        this.service.service_price = ((Number(this.service.service_rate.replace('%', '')) / 100) * Number(this.taskInfo.total_amount) + Number(this.service.service_fixed_amount))
      }
      if (this.taskInfo.support_transport_service == '2') {
        this.service.service_rate = Number(business.buyer_service_rate) !== 0 ? business.buyer_service_rate : currencyInfo.buyer_service_rate
        this.service.service_fixed_amount = this.taskInfo.business.buyer_fixed_amount
        this.service.service_price = ((Number(this.service.service_rate.replace('%', '')) / 100) * Number(this.taskInfo.total_amount) + Number(this.service.service_fixed_amount))
      }
      this.form.amount = this.$decimalFormat((Number(this.taskInfo.total_amount) + this.service.service_price)* Number(this.rate),2)
      this.taskInfo.service_rate = this.service.service_rate
      this.taskInfo.service_fixed_amount = this.service.service_fixed_amount
      this.service.service_price = this.$decimatFormat(this.service.service_price,2)
      this.taskInfo.currency_rate = this.rate
      this.taskInfo.service = this.service
      this.$store.commit('updateTaskInfo', this.taskInfo)
      if (this.btnType) {
        this.calService()
      }
      let query = {
        id: this.taskInfo.business_id
      }
      let list = await api.getListByWebsite(this, query)
      // if(!this.btnType){
      //   if(this.taskInfo.currency == list.body.result[0].default_currency) {
      //     if(this.taskInfo.support_transport_service == '1'){
      //       if(list.body.result[0].single_service_rate != '0') {
      //         this.service.service_rate = list.body.result[0].single_service_rate
      //         this.service.service_price = ((Number(this.rate) * Number(list.body.result[0].single_service_rate.replace('%', '')) / 100) * Number(this.taskInfo.total_amount)).toFixed(2)
      //         this.form.amount = (this.taskInfo.total_amount * Number(this.form.rate)).toFixed(2)
      //       }else{
      //         if(this.rate_difference && this.rate_difference != '0'){
      //           this.form.amount = (this.taskInfo.total_amount * Number(this.form.rate)).toFixed(2)
      //         }else{
      //           this.service.service_rate = '0.00'
      //           this.service.service_price = '0.00'
      //         }
      //       }
      //       if(list.body.result[0].single_exchange_rate > 0){
      //         this.calRate()
      //       }
      //     }
      //     if(this.taskInfo.support_transport_service == '2'){
      //       if(list.body.result[0].buyer_service_rate != '0') {
      //         this.service.service_rate = list.body.result[0].buyer_service_rate
      //         this.service.service_price = ((Number(this.rate) * Number(list.body.result[0].buyer_service_rate.replace('%', '')) / 100) * Number(this.taskInfo.total_amount)).toFixed(2)
      //         this.form.amount = (this.taskInfo.total_amount * Number(this.form.rate)).toFixed(2)
      //       }else{
      //         if(this.rate_difference && this.rate_difference != '0'){
      //           this.form.amount = (this.taskInfo.total_amount * Number(this.form.rate)).toFixed(2)
      //         }else{
      //           this.service.service_rate = '0.00'
      //           this.service.service_price = '0.00'
      //         }
      //       }
      //       if(list.body.result[0].buyer_exchange_rate > 0){
      //         this.calRate()
      //       }
      //     }
      //   }
      // }
      _.each(this.CURRENCIES, item => {
        if (item.value == this.taskInfo.currency) {
          this.currency = item.name
        }
      })
      if (this.taskInfo.business_id == 7) {
        this.form.rate = 6.7
        this.calRate()
      }
    },
    submit () {
      this.$refs['form'].validate((valid, errors) => {
        if (!valid || !this.isEmptyErrors) {
          return false
        }
        _.each(this.singleList, item => {
          if (item.name == this.form.single_name) {
            this.form.single_id = item.id
          }
        })
        console.log(this.form)
        this.taskInfo.conditions = this.form
        this.$store.commit('updateTaskInfo', this.taskInfo)
        this.$emit('success')
      })
    },
    async getUserInfo () {
      let res = await api.getUserInfo(this)
      this.form.single_id = res.body.result.account_id
    },
    async getSingleList () {
      let res = await api.getSingleList(this)
      this.singleList = res.body.result || []
    },
    // calRate () {
    //   if (!isNaN(this.form.rate) && !isNaN(this.taskInfo.total_amount)) {
    //     this.form.amount = (this.taskInfo.total_amount * Number(this.form.rate)).toFixed(2)
    //   }
    //   this.calService()
    // },
    calAmount () {
      if (!isNaN(this.form.amount) && !isNaN(this.taskInfo.total_amount)) {
        this.calService()
      }
    },
    calServicePrice () {
      console.log(this.form, this.taskInfo, this.rate)
      let service_rate = ((((Number(this.service.service_price)) - Number(this.service.service_fixed_amount)) / Number(this.taskInfo.total_amount)) * 100)
      service_rate=this.$decimalFormat(service_rate,2)
      this.service.service_rate = service_rate + '%'
      if (!isNaN(this.form.rate) && !isNaN(this.taskInfo.total_amount)) {
        let t=(((Number(this.service.service_price) + (Number(this.taskInfo.total_amount))) * Number(this.rate)))
        this.form.amount = this.$decimalFormat(t,2)
      }
    },
    calService () {
      let service_rate = ((Number(this.form.amount) / Number(this.rate) - Number(this.taskInfo.total_amount) - Number(this.service.service_fixed_amount)) / Number(this.taskInfo.total_amount) * 100)
      service_rate=this.$decimalFormat(service_rate,2)
      this.service.service_rate = service_rate + '%'
      const tempPrice = ((Number(this.taskInfo.total_amount) * Number(service_rate) / 100) + Number(this.service.service_fixed_amount))
      this.service.service_price = this.$decimalFormat(tempPrice,2)
    }
  },
  watch: {
    'form.transport_amount_charge_type': function (val) {
      if (~~val === 1 || ~~val === 2) {
        this.form.package_forwarding_fee = '0.00'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.addressName{
  line-height: 20px;
  margin-bottom: 10px;
  margin-left: 5px;
  color: #666;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/condition/Form.vue